import { http } from "@/http/axios.js";

// 锚点候选值：已启用的基准规则，返回 { enumCode, enumText }。
export function getMachineRuleAnchorListAPI() {
  return http({
    url: "/admin/review/v2/rule/anchor/list",
    method: "get",
  });
}

export function getMachineRuleListAPI(params) {
  return http({
    url: "/admin/review/v2/rule/page",
    method: "get",
    params,
  });
}

// 按规则 id 切换状态，status 为布尔值；组开关使用另一接口。
export function changeMachineRuleStatusAPI(data) {
  return http({
    url: "/admin/review/v2/rule/editStatus",
    method: "post",
    data,
  });
}

// status 为目标状态；enabledRuleList 返回同组其他启用规则，分组由后端判断。
export function getMachineRuleStatusPrecheckAPI(params) {
  return http({
    url: "/admin/review/v2/rule/editStatus/precheck",
    method: "get",
    params,
  });
}

// 组级字段与策略配置放在 ruleGroupList，规则级启停由 editStatus 处理。
export function createMachineRuleAPI(data) {
  return http({
    url: "/admin/review/v2/rule/add",
    method: "post",
    data,
  });
}

// 详情策略行包含嵌套的 strategy 元信息，回显时需拍平。
export function getMachineRuleDetailAPI(id) {
  return http({
    url: "/admin/review/v2/rule/detail",
    method: "get",
    params: { id },
  });
}

// 编辑沿用新增结构，并回传规则 id、已有组的 id/groupCode。
export function editMachineRuleAPI(data) {
  return http({
    url: "/admin/review/v2/rule/edit",
    method: "post",
    data,
  });
}

// 一次返回策略元信息、候选值和运算符，无需再请求策略详情。
export function getStrategyListAPI(params) {
  return http({
    url: "/admin/review/v2/strategy/list",
    method: "get",
    params,
  });
}
